const ages = [
  48002,
  47854,
  47873,
  48589,
  49235,
  47570,
  48123,
  46570,
  47490,
  45708,
  46394,
  50054,
  51401,
  50393,
  52300,
  51049,
  49043,
  48862,
  50452,
  51529,
  52498,
  51039,
  52262,
  55007,
  58778,
  61856,
  62918,
  63505,
  65530,
  67355,
  65969,
  64295,
  63862,
  63690,
  63726,
  64672,
  61249,
  62001,
  65821,
  69210,
  72590,
  77702,
  81017,
  84714,
  88730,
  91956,
  87477,
  73825,
  72558,
  71164,
  71623,
  71516,
  70343,
  66671,
  60275,
  57341,
  55532,
  53990,
  51394,
  53614,
  54765,
  53628,
  54785,
  55362,
  60566,
  63899,
  64537,
  57264,
  49521,
  48085,
  47650,
  43963,
  41375,
  38435,
  32446,
  29396,
  31777,
  27573,
  26206,
  22588,
  20680,
  17300,
  15517,
  13033,
  11125,
  10055,
  8589,
  7515,
  6284,
  5116,
  16993
];

export default ages;
